const CHECKOUT_URL =
  'https://barberoscheckout.ebookditales.com/cart/51844014407963:1'

export const scrollToPurchase = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }
  window.open(CHECKOUT_URL, '_blank')
}
